<template>
  <div id="device_tab"
       class="main-tab main-tab-o">
    <div class="dv-reds-top">
      <img src="../assets/images/icon_newsds_bg.png"
           class="img-reds-bg">
      <div class="dv-content-reds">
        <div class="dv-rou-content">
          <router-link class="tv-routor"
                       to='/'>首页</router-link>
          <div class="tv-routor">/</div>
          <router-link class="tv-routor"
                       to='/news'>新闻实事</router-link>
          <div class="tv-routor">/</div>
          <router-link class="tv-routor"
                       to=''>详情</router-link>
        </div>
        <div class="dv-news-title">{{ info.title }}</div>
        <div class="dv-news-title1">{{ info.createdate }}</div>
        <div class="dv-reds-item-bg_newsds"
             v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/api'
const aes = require('../utils/aes.js')
export default {
  data () {
    return {
      id: '',
      info: '',
      content: '',//富文本
    }
  },
  created () {
    var current = this.$route.query.current
    this.id = this.$route.query.id
    switch (current) {
      case '1':
        this.newsdetail()
        break;
      case '2':
        this.culturedetail()
        break;
      case '3':
        this.aspirationdetail()
        break;
    }
  },
  methods: {
    //新闻详情
    newsdetail () {
      let parm = {
        FKEY: api.getFKEY(),
        newsid: aes.Encrypt(this.id)
      }
      api.newsdetail(parm).then((res) => {
        this.info = res.data
        this.content = res.data.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'");
      })
    },
    //医院文化详情
    culturedetail () {
      let parm = {
        FKEY: api.getFKEY(),
        newsid: aes.Encrypt(this.id)
      }
      api.culturedetail(parm).then((res) => {
        this.info = res.data
        this.content = res.data.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'");
      })
    },
    //患者心声详情
    aspirationdetail () {
      let parm = {
        FKEY: api.getFKEY(),
        newsid: aes.Encrypt(this.id)
      }
      api.aspirationdetail(parm).then((res) => {
        this.info = res.data
        this.content = res.data.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'");
      })
    },
  }

}
</script>

<style>
.dv-reds-top {
  width: 100%;
  height: fit-content;
  position: relative;
  display: flex;
  /* margin-top: 40px; */
  flex-direction: column;
}
.img-reds-bg {
  width: 100%;
  position: absolute;
  /* top: 40px; */
}
.dv-content-reds {
  width: calc(100% - 600px);
  margin-left: 300px;
  min-height: 800px;
  /* margin-top: 40px; */
  display: flex;
  flex-direction: column;
  text-align: left;
}
.tv-routor {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #8271ae;
  margin-top: 20px;
}
.dv-rou-content {
  display: flex;
  flex-direction: row;
}
.dv-reds-item-bg_newsds {
  width: 100%;
  min-height: 500px;
  background: white;
  padding: 20px;
  margin-top: 50px;
  margin-bottom: 100px;
  border: 2px solid #eef0f5;
  -moz-user-select: -moz-all;
  -o-user-select: -moz-all;
  -khtml-user-select: -moz-all;
  -webkit-user-select: -moz-all;
  -ms-user-select: -moz-all;
  user-select: -moz-all;
}
.dv-news-title {
  width: 100%;
  font-size: 28px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
  text-align: center;
  margin-top: 180px;
}
.dv-news-title1 {
  width: 50%;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #707070;
  text-align: center;
  margin-top: 20px;
  margin-left: 25%;
}
</style>